import React, { useEffect, useState } from 'react';
import { CondicionesPago, LasMonedas, TiposDocsCrearDoc } from '../Comunes/Listas';
import Select from 'react-select';

const Encabezado = (props) => {

    function CheckClienteGenerico() {
        return props.Gestor.TipoDocumento === '4' ||
            props.Gestor.TipoDocumento === '2' ||
            props.Gestor.TipoDocumento === '3' ? (
            <div className="checkbox-container">
                <input
                    type="checkbox"
                    id="SN"
                    name="SN"
                    checked={props.Gestor.SN === 'S'}
                    onChange={props.Modificar}
                />
                <label className='col-form-span' htmlFor="SN"> Genérico</label>
            </div>
        ) : null;
    }

    const [DocumentosDinamicos, setDocumentosDinamicos] = useState([]);
    useEffect(() => {
        switch (props.Gestor.TipoDocumento) {
            case '2':
                setDocumentosDinamicos([{ value: '3', span: 'Nota Crédito' }, { value: '1', span: 'Fact. Electrónica' }, { value: '9', span: 'Fact. Exportación' }, { value: '4', span: 'Tiquete Eléct.' }]);
                break;
            case '3':
                setDocumentosDinamicos([{ value: '1', span: 'Fact. Electrónica' }, { value: '9', span: 'Fact. Exportación' }, { value: '2', span: 'Nota Débito' }, { value: '4', span: 'Tiquete Eléct.' }]);
                break;
            case 'C':
                setDocumentosDinamicos([{ value: 'N', span: 'Nueva Cotización' }, { value: 'C', span: 'Facturar Cotización' }]);
                break;
            case 'P':
                setDocumentosDinamicos([{ value: 'N', span: 'Nuevo Borrador' }, { value: 'P', span: 'Modificar Borrador' }]);
                break;
            case 'O':
                setDocumentosDinamicos([{ value: 'N', span: 'Nueva Orden Pedido' }, { value: 'O', span: 'Facturar Orden Pedido' }]);
                break;
            case '10':
                setDocumentosDinamicos([{ value: '1', span: 'Fact. Electrónica' }, { value: '2', span: 'Nota Débito' }, { value: '3', span: 'Nota Crédito' }, { value: '4', span: 'Tiquete Eléct.' }, { value: '9', span: 'Fact. Exportación' }]);
                break;
            default:

        }
    }, [props.Gestor.TipoDocumento])



    return (
        <>
            <div className="row">
                <div className="col-25">
                    <span className="col-form-span">Tipo </span>
                    <select id="TipoDocumento" name="TipoDocumento" className="form-group"
                        onChange={props.Modificar} value={props.Gestor.TipoDocumento}>
                        {TiposDocsCrearDoc.map((option, i) => (
                            <option key={i} value={option.value}>{option.span}</option>
                        ))}</select>
                </div>
                <div className="col-75">
                    {props.Gestor.TipoDocumento === '3' || props.Gestor.TipoDocumento === '2' || props.Gestor.TipoDocumento === 'C' || props.Gestor.TipoDocumento === 'P' || props.Gestor.TipoDocumento === 'O'|| props.Gestor.TipoDocumento === '10' ?
                        (<div className='row'>
                            <div className="col-25">
                                <span className="col-form-span">Referencia </span>
                                <select id="cboTipoDocRef" name="cboTipoDocRef" className="form-group" onChange={props.Modificar} value={props.Gestor.cboTipoDocRef}>
                                    {DocumentosDinamicos.map((option, i) => (
                                        <option key={i} value={option.value}>{option.span}</option>
                                    ))}</select>
                            </div>

                            <div className="col-50">
                                {props.DocumentosReferenciados.length > 0 ? <>
                                    <span className="col-form-span">Documento </span>
                                    <select id="cboDocRef" name="cboDocRef" className="form-group" onChange={props.Modificar} value={props.Gestor.cboDocRef}>
                                        {props.DocumentosReferenciados.map((option, i) => (
                                            <option key={i} value={option.Codigo}>{option.Detalle}</option>
                                        ))}</select>
                                </>
                                    : null}
                            </div>

                        </div>)
                        : null
                    }
                </div>
            </div>

            <div className="row">
                <div className="col-50">
                    <div className='row'>
                        <div className="col-25">
                            <span className="col-form-span">Condición </span>
                            <select id="CondicionVenta" name="CondicionVenta" className="form-group" onChange={props.Modificar} value={props.Gestor.CondicionVenta}>
                                {CondicionesPago.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}</select>
                        </div>

                        <div className="col-25">
                            <span className="col-form-span">Fecha </span>
                            <input type="date" id="DocDate" name="DocDate" autoComplete='off' value={props.Gestor.DocDate} onChange={props.Modificar}></input>
                        </div>


                        <div className="col-25">
                            <span className="col-form-span">Vencimiento </span>
                            <input type="date" id="Vencimiento" name="Vencimiento" autoComplete='off' value={props.Gestor.Vencimiento} onChange={props.Modificar}></input>
                        </div>
                    </div>
                </div>

                <div className="col-25">
                    <div className='row'>
                        <div className="col-50">
                            <span className="col-form-span">TC </span>
                            <input type="text" id="TC" name="TC" autoComplete='off' value={props.Gestor.TC} onChange={props.Modificar}></input>
                        </div>
                        <div className="col-50">
                            <span className="col-form-span">Moneda </span>
                            <select id="CodigoMoneda" name="CodigoMoneda" className="form-group" onChange={props.Modificar} value={props.Gestor.CodigoMoneda}>
                                {LasMonedas.map((option, i) => (
                                    <option key={i} value={option.value}>{option.span}</option>
                                ))}</select>
                        </div>
                    </div>
                </div>

                <div className="col-25">
                    <span className="col-form-span">Actividad </span>
                    <select id="CodigoActividad" name="CodigoActividad" className="form-group" onChange={props.Modificar} value={props.Gestor.CodigoActividad}>
                        {props.MisActividades.map((option, i) => (
                            <option key={i} value={option.CodigoActividad}>{option.NombreActividad}</option>
                        ))}</select>
                </div>
            </div>

            <div className="row">
                {(props.Gestor.TipoDocumento === '1' ||
                    props.Gestor.TipoDocumento === '2' ||
                    props.Gestor.TipoDocumento === '3' ||
                    props.Gestor.TipoDocumento === '4' ||
                    props.Gestor.TipoDocumento === '8' ||
                    props.Gestor.TipoDocumento === '9' ||
                    props.Gestor.TipoDocumento === '10' ||
                    props.Gestor.TipoDocumento === 'C' ||
                    props.Gestor.TipoDocumento === 'P' ||
                    props.Gestor.TipoDocumento === 'O') && props.Gestor.SN === 'N' ? (<>
                        <div className="col-50">
                            <span className="col-form-span" >Cliente </span>
                            <Select name="CedulaCliente" id="CedulaCliente"
                                value={props.selectedOption}
                                onChange={props.handleChange}
                                options={props.ListaSocios} />
                        </div>
                        <div className="col-25">
                            <span className="col-form-span">Actividad Cliente</span>
                            <select id="CodigoActividadReceptor" name="CodigoActividadReceptor" className="form-group" onChange={props.Modificar} value={props.Gestor.CodigoActividadReceptor}>
                                {props.ActividadesCliente.filter(option => option.FAC_CED_CLI === props.Gestor.CedulaCliente).map((option, i) => (
                                    <option key={i} value={option.CODIGO_ACTIVIDAD}>{option.CODIGO_ACTIVIDAD +'-'+option.NOMBRE_ACTIVIDAD}</option>
                                ))}</select>
                        </div>
                        <div className="col-25">
                            {CheckClienteGenerico()}
                        </div>

                    </>) : (<>

                        <div className="col-25">
                            <span className="col-form-span">Nombre </span>
                            <input type="text" id="Nombre" name="Nombre" autoComplete='off' value={props.Gestor.Nombre} onChange={props.Modificar}></input>
                        </div>
                        <div className="col-25">
                            {CheckClienteGenerico()}
                        </div>
                        <div className='col-25'></div>
                    </>)}




            </div>
        </>
    );
};

export default Encabezado;